export const DEFAULT_AUTOMATION_NAME = 'New Automation';

export type AutomationTitleMode = 'auto' | 'custom';

export type AutomationIdentity = {
  title?: unknown;
  titleMode?: AutomationTitleMode | null;
  workflowName?: string | null;
};

const LEGACY_AUTOMATIC_TITLES = new Set([
  '',
  'Automation',
  DEFAULT_AUTOMATION_NAME,
  'No Workflow Selected',
]);

export function readAutomationTitle(title: unknown): string {
  if (typeof title === 'string') return title.trim();
  if (
    title &&
    typeof title === 'object' &&
    typeof (title as { toString?: unknown }).toString === 'function'
  ) {
    return String(title).trim();
  }
  return '';
}

export function readAutomationTitleEditorValue(
  input: { value: string } | null | undefined,
  fallback: string
): string {
  return input?.value ?? fallback;
}

export function hasCustomAutomationTitle(
  identity: AutomationIdentity
): boolean {
  if (identity.titleMode === 'custom') return true;
  if (identity.titleMode === 'auto') return false;

  const title = readAutomationTitle(identity.title);
  if (LEGACY_AUTOMATIC_TITLES.has(title)) return false;
  return title !== identity.workflowName?.trim();
}

export function resolveAutomationName(
  identity: AutomationIdentity,
  defaultName = DEFAULT_AUTOMATION_NAME
): string {
  const title = readAutomationTitle(identity.title);
  if (hasCustomAutomationTitle(identity) && title) return title;
  return identity.workflowName?.trim() || defaultName;
}

export function resolveAutomationTitleWrite(
  identity: AutomationIdentity,
  nextTitle: string,
  source: 'user' | 'workflow'
): { title: string; titleMode: AutomationTitleMode } | null {
  if (source === 'workflow' && hasCustomAutomationTitle(identity)) {
    return null;
  }

  const normalizedTitle = nextTitle.trim();
  if (source === 'user' && normalizedTitle) {
    return { title: normalizedTitle, titleMode: 'custom' };
  }

  return {
    title:
      normalizedTitle ||
      identity.workflowName?.trim() ||
      DEFAULT_AUTOMATION_NAME,
    titleMode: 'auto',
  };
}
